import {
  words,
  marginOfSessionTime,
} from './globalState';
import {
  getValidKeyPairs,
  certificationWithKey,
  setSignatureByAddressMain,
  signWithKey,
  getAddressFromKey,
  checkIfAddressIsMatchedWithAnAddress,
} from './keysAndSigning';
import {
  setAddressesInCookie,
} from './monacottoMisc';
import {
  syncHttpRequest2,
} from './utils';

// 「許可履歴」ボタン押下 HANDLE CLICK GET PERMIT HISTORY
async function handleClickGetPermitHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs) {
  // let addressActual;
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  // state固定
  const stateFixed = {
    addressMain: state.getPermissionHistory.addressMain,
    lastEvaluatedSortKey: pagingIndex >= 1 ? state.getPermissionHistory.lastEvaluatedKey.permit[pagingIndex - 1].addressPermitTo : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getPermitHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {
    // state固定
    stateFixed[address] = {
      // addressCoinType: state.session[address].addressCoinType,
      sessionId: state.session[address].sessionId,
      expirationOfSession: state.session[address].expirationOfSession,
    };

    if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
      certifications.push({
        // addressCoinType: stateFixed[address].addressCoinType,
        address: address,
        sessionId: stateFixed[address].sessionId,
        lastEvaluatedSortKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedSortKey : null,
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    "body": {
      action: 'permit',
      certifications: certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_some_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'permitHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });

        // dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
        //   value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession'], 'addressCoinType': response.body[address]['addressCoinType']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'permit', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'permit', pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex', 'permit'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getPermissionHistory.addressMain === undefined || state.getPermissionHistory.addressMain === null || state.getPermissionHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchPermitHistory',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「被許可履歴」ボタン押下 HANDLE CLICK GET PERMITTED HISTORY
async function handleClickGetPermittedHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs) {
  // let addressActual;
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  // state固定
  const stateFixed = {
    addressMain: state.getPermissionHistory.addressMain,
    lastEvaluatedSortKey: pagingIndex >= 1 ? state.getPermissionHistory.lastEvaluatedKey.permitted[pagingIndex - 1].addressOwner : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getPermittedHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {
    // state固定
    stateFixed[address] = {
      // addressCoinType: state.session[address].addressCoinType,
      sessionId: state.session[address].sessionId,
      expirationOfSession: state.session[address].expirationOfSession,
    };

    if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
      certifications.push({
        // addressCoinType: stateFixed[address].addressCoinType,
        address: address,
        sessionId: stateFixed[address].sessionId,
        lastEvaluatedSortKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedSortKey : null,
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    "body": {
      action: 'permitted',
      certifications: certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_some_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'permittedHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'permitted', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'permitted', pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex', 'permitted'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getPermissionHistory.addressMain === undefined || state.getPermissionHistory.addressMain === null || state.getPermissionHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchPermittedHistory',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「包括的被許可履歴」ボタン押下 HANDLE CLICK GET PERMITTED INCLUSIVELY HISTORY
async function handleClickGetPermittedInclusivelyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs) {
  // let addressActual;
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  // state固定
  const stateFixed = {
    addressMain: state.getPermissionHistory.addressMain,
    lastEvaluatedSortKey: pagingIndex >= 1 ? state.getPermissionHistory.lastEvaluatedKey.permittedInclusively[pagingIndex - 1].addressOwner : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getPermittedInclusivelyHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {
    // state固定
    stateFixed[address] = {
      // addressCoinType: state.session[address].addressCoinType,
      sessionId: state.session[address].sessionId,
      expirationOfSession: state.session[address].expirationOfSession,
    };

    if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
      certifications.push({
        // addressCoinType: stateFixed[address].addressCoinType,
        address: address,
        sessionId: stateFixed[address].sessionId,
        lastEvaluatedSortKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedSortKey : null,
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    "body": {
      action: 'permittedInclusively',
      certifications: certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_some_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'permittedInclusivelyHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'permittedInclusively', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'permittedInclusively', pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex', 'permittedInclusively'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getPermissionHistory.addressMain === undefined || state.getPermissionHistory.addressMain === null || state.getPermissionHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchPermittedInclusivelyHistory',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「許可リクエスト履歴」ボタン押下 HANDLE CLICK GET REQUEST PERMISSION HISTORY
async function handleClickGetRequestPermissionHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  // state固定
  const stateFixed = {
    addressMain: state.getPermissionHistory.addressMain,
    lastEvaluatedSortKey: pagingIndex >= 1 ? state.getPermissionHistory.lastEvaluatedKey.requestPermission[pagingIndex - 1].addressOwner : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getRequestPermissionHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {
    // state固定
    stateFixed[address] = {
      // addressCoinType: state.session[address].addressCoinType,
      sessionId: state.session[address].sessionId,
      expirationOfSession: state.session[address].expirationOfSession,
    };

    if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
      certifications.push({
        // addressCoinType: stateFixed[address].addressCoinType,
        address: address,
        sessionId: stateFixed[address].sessionId,
        lastEvaluatedSortKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedSortKey : null,
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    "body": {
      action: 'requestPermission',
      certifications: certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_some_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'requestPermissionHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'requestPermission', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'requestPermission', pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex', 'requestPermission'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getPermissionHistory.addressMain === undefined || state.getPermissionHistory.addressMain === null || state.getPermissionHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchrequestPermissionHistory',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「被許可リクエスト履歴」ボタン押下 HANDLE CLICK GET REQUESTED PERMISSION HISTORY
async function handleClickGetRequestedPermissionHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  // state固定
  const stateFixed = {
    addressMain: state.getPermissionHistory.addressMain,
    lastEvaluatedSortKey: pagingIndex >= 1 ? state.getPermissionHistory.lastEvaluatedKey.requestedPermission[pagingIndex - 1].addressMain : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getRequestedPermissionHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {
    // state固定
    stateFixed[address] = {
      // addressCoinType: state.session[address].addressCoinType,
      sessionId: state.session[address].sessionId,
      expirationOfSession: state.session[address].expirationOfSession,
    };

    if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
      certifications.push({
        // addressCoinType: stateFixed[address].addressCoinType,
        address: address,
        sessionId: stateFixed[address].sessionId,
        lastEvaluatedSortKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedSortKey : null,
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    "body": {
      action: 'requestedPermission',
      certifications: certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_some_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'requestedPermissionHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'requestedPermission', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'requestedPermission', pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex', 'requestedPermission'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getPermissionHistory.addressMain === undefined || state.getPermissionHistory.addressMain === null || state.getPermissionHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchrequestedPermissionHistory',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「委任した履歴」ボタン押下 HANDLE CLICK GET DELEGATE HISTORY
async function handleClickGetDelegateHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  // state固定
  const stateFixed = {
    addressMain: state.getPermissionHistory.addressMain,
    lastEvaluatedSortKey: pagingIndex >= 1 ? state.getPermissionHistory.lastEvaluatedKey.delegate[pagingIndex - 1].addressDelegateTo : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getDelegateHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {
    // state固定
    stateFixed[address] = {
      sessionId: state.session[address].sessionId,
      expirationOfSession: state.session[address].expirationOfSession,
    };

    if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
      certifications.push({
        address: address,
        sessionId: stateFixed[address].sessionId,
        lastEvaluatedSortKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedSortKey : null,
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    "body": {
      action: 'delegate',
      certifications: certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_some_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'delegateHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'delegate', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'delegate', pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex', 'delegate'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getPermissionHistory.addressMain === undefined || state.getPermissionHistory.addressMain === null || state.getPermissionHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchDelegateHistory',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「委任された履歴」ボタン押下 HANDLE CLICK GET DELEGATED HISTORY
async function handleClickGetDelegatedHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  // state固定
  const stateFixed = {
    addressMain: state.getPermissionHistory.addressMain,
    lastEvaluatedSortKey: pagingIndex >= 1 ? state.getPermissionHistory.lastEvaluatedKey.delegated[pagingIndex - 1].addressDelegateFrom : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getDelegatedHistory,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {
    // state固定
    stateFixed[address] = {
      sessionId: state.session[address].sessionId,
      expirationOfSession: state.session[address].expirationOfSession,
    };

    if (stateFixed[address].expirationOfSession >= now + marginOfSessionTime) {
      certifications.push({
        address: address,
        sessionId: stateFixed[address].sessionId,
        lastEvaluatedSortKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedSortKey : null,
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  const extendedCertificationProperties = [
  ];

  if (keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'matchedKey', network: state.networkMona, language: state.language });
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'information', stateFixed, certifications, clientTime: now, extendedCertificationProperties, signingMode: 'firstKey', network: state.networkMona, language: state.language });
  }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties, messageType: 'information', language: state.language });
  }

  // 対象がなければ戻る。
  // NFC, BCの場合、キーカードを要求して2周目。

  if (
    certifications.length === 0 ||
    stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'nfcNative') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
        return {
          status: 'rejected',
          message: 'nfcNativeRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    "body": {
      action: 'delegated',
      certifications: certifications,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_some_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'delegatedHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain] !== undefined &&
         (response.body[stateFixed.addressMain].certificatedBy === 'signature' || response.body[stateFixed.addressMain].certificatedBy === 'sessionId')) {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'delegated', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'lastEvaluatedKey', 'delegated', pagingIndex], value: null });
      }

      // pagingIndexが指定されているということは、前回の検索時からaddressMainが変更されていないということ。(変更するとリセットされてしまう。)
      // addressMainが指定されていないということは、後ページ検索ではない。
      // なぜならば、addressMainが指定されていない状態にするには、前回の検索のあと、addressMainを削除しなければならないから。

      dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'pagingIndex', 'delegated'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getPermissionHistory.addressMain === undefined || state.getPermissionHistory.addressMain === null || state.getPermissionHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getPermissionHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // cookie情報更新(アドレス情報)
      const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      const cookiesNew = [
            {
              action: 'searchDelegatedHistory',
              addressType: 'addressMain',
              description: `${userName}`,
              time: now,
              address: stateFixed.addressMain
            },
      ];

      setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// 「許可リクエスト」ボタン押下 HANDLE CLICK REQUEST PERMISSION
async function handleClickRequestPermission(state, dispatch, cookies, setCookie, keyPairs) {
  let addressActual;
  let request = {};
  let messages = {};
  let signature;

  // state固定
  const stateFixed = {
    addressMain: state.requestPermission.addressMain,
    addressOwner: state.requestPermission.addressOwner,
    royaltyPercentage: state.requestPermission.royaltyPercentage.value,
    signatureVersion: state.config.clientParameters.signatureVersion.requestPermission,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 必須項目チェック
  // if (stateFixed.addressMain === undefined || stateFixed.addressMain === null || stateFixed.addressMain === '') {
  //   dispatch({ type: 'setNotification', key: 'notification', value: words.mainAddressMustBeFilled[state.language] });
  //   return;
  // }

  if (stateFixed.addressOwner === undefined || stateFixed.addressOwner === null || stateFixed.addressOwner === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.ownerAddressMustBeFilled[state.language] });
    return;
  }

  if (stateFixed.royaltyPercentage === undefined || stateFixed.royaltyPercentage === null || stateFixed.royaltyPercentage === '') {
    stateFixed.royaltyPercentage = 0;
  }

  // 数量チェック
  if (stateFixed.royaltyPercentage > 90) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.royaltyPercentageMustBeEqualOrSmallerThan90[state.language] });
    return;
  }

  if (stateFixed.royaltyPercentage < 0) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.royaltyPercentageMustBeEqualOrLargerThan0[state.language] });
    return;
  }


  // 署名
  const clientTime = Date.now();

  const getMessage = (addressMain) => {
    return `I request the owner of ${stateFixed.addressOwner} to permit me(${addressMain}) to sell tokens owned(issued) by him/her for the ${stateFixed.royaltyPercentage}% royalty. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
  };

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' && keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined) {
    const keyPair = keyPairsInPool[stateFixed.addressMain].keyPair;
    addressActual = stateFixed.addressMain;

    const result = signWithKey(state, dispatch, keyPair, getMessage(stateFixed.addressMain), state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    const keyPair = keyPairs[0];
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return { status: 'rejected' };
    }

    // addressMainが指定されていれば、アドレスチェックを行う。
    // 指定されていなければ、addressMainActualをaddressMainとして扱う。
    if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
      if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressMain, addressCheck: stateFixed.addressCheck, language: state.language })) {
        return { status: 'rejected' };
      }
    }
    else {
      stateFixed.addressMain = addressActual;
    }

    result = signWithKey(state, dispatch, keyPair, getMessage(stateFixed.addressMain), state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (stateFixed.walletType === 'mpurse') {
    const result = await window.mpurse.getAddress()
    .then( (result) => {
      addressActual = result;

      // addressMainが指定されていれば、アドレスチェックを行う。
      // 指定されていなければ、addressMainActualをaddressMainとして扱う。
      if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
        if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressMain, addressCheck: stateFixed.addressCheck, language: state.language })) {
          return 'rejected';
        }
      }
      else {
        stateFixed.addressMain = addressActual;
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    try {
      signature= await window.mpurse.signMessage(getMessage(stateFixed.addressMain)).then( result => result );
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return;
    }
  }
  else if (
    stateFixed.walletType === 'keypool' &&
    state.active.addressMain !== undefined && state.active.addressMain !== null && state.active.addressMain !== '' &&
    keyPairsInPool[state.active.addressMain]?.keyPair !== undefined
  ) {
    const keyPair = keyPairsInPool[state.active.addressMain].keyPair;
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return { status: 'rejected' };
    }

    // addressMainが指定されていれば、アドレスチェックを行う。
    // 指定されていなければ、addressMainActualをaddressMainとして扱う。
    if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
      if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressMain, addressCheck: stateFixed.addressCheck, language: state.language })) {
        return { status: 'rejected' };
      }
    }
    else {
      stateFixed.addressMain = addressActual;
    }

    result = signWithKey(state, dispatch, keyPair, getMessage(stateFixed.addressMain), state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (stateFixed.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcRequired',
    };
  }
  else if (stateFixed.walletType === 'nfcNative') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcNativeRequired',
    };
  }
  else { // qr
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    return {
      status: 'rejected',
      message: 'bcRequired',
    };
  }

  // GO！

  request.body = JSON.stringify({
    body: {
      addressMain: stateFixed.addressMain,
      addressOwner: stateFixed.addressOwner,
      addressMainActual: addressActual,
      royaltyPercentage: stateFixed.royaltyPercentage,
      clientTime: clientTime,
      signature: signature,
      signatureVersion: stateFixed.signatureVersion,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/request_permission';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "order expired.": words.orderExpired[state.language],
    "out of service": words.outOfService[state.language],
    "user does not exist.": words.addressIsNotBeRegistered[state.language],
    "you are not delegated from main address.": words.norIsTheSignatureDelegatedFromMainAddress[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain], value: {'sessionId': response.body.sessionId.addressMain, 'expirationOfSession': response.body.expirationOfSession.addressMain} });

    if (addressActual !== stateFixed.addressMain) {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': response.body.sessionId.addressMainActual, 'expirationOfSession': response.body.expirationOfSession.addressMainActual} });
    }

    // addressMainが指定されていなかった場合は、dispatchする。
    if (state.requestPermission.addressMain === undefined || state.requestPermission.addressMain === null || state.requestPermission.addressMain === '') {
      dispatch({ type: 'setStateMultiLayers', keys: ['requestPermission', 'addressMain'], value: stateFixed.addressMain });
    }

    // オーダーNo.通知欄表示
    // dispatch({ type: 'setNotification', key: 'notification', value: words.orderAcceptedOrderNo[state.language] + response.body.orderNo + words.orderAcceptedOrderNo2[state.language] });

    // cookie情報更新(アドレス情報)
    const ownerName = state.usersGeneralIndex[stateFixed.addressOwner] !== undefined ? state.usersGeneralIndex[stateFixed.addressOwner].userName : stateFixed.addressOwner;
    const cookiesNew = [
          {
            action: 'requestPermissionToExhibit',
            addressType: 'addressMain',
            description: `${ownerName} ${stateFixed.royaltyPercentage}%`,
            time: clientTime,
            address: stateFixed.addressMain
          },
    ];

    if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressOwner )) {
      cookiesNew.push(
          {
            action: 'requestPermissionToExhibit',
            addressType: 'addressOwner',
            description: `${ownerName} ${stateFixed.royaltyPercentage}%`,
            time: clientTime,
            address: stateFixed.addressOwner
          },
      );
    }

    setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressMain, cookiesNew, clientParameters: state.config.clientParameters });
  }
  else {
  }

  return response;
}


// 「許可」ボタン押下 HANDLE CLICK PERMIT
async function handleClickPermit(state, dispatch, cookies, setCookie, keyPairs) {
  let addressActual;
  let request = {};
  let messages = {};
  let signature;

  // state固定
  const stateFixed = {
    action: state.permit.action,
    mode: state.permit.mode,
    addressOwner: state.permit.addressOwner,
    addressPermitTo: state.permit.addressPermitTo,
    addressPayRoyaltyTo: state.permit.addressPayRoyaltyTo,
    // ownerName: state.permit.ownerName,
    royaltyPercentage: state.permit.royaltyPercentage.value,
    // acceptTheTermsAndConditions: state.acceptTheTermsAndConditions,
    signatureVersion: state.config.clientParameters.signatureVersion.permit,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 必須項目チェック
  // if (stateFixed.addressOwner === undefined || stateFixed.addressOwner === null || stateFixed.addressOwner === '') {
  //   dispatch({ type: 'setNotification', key: 'notification', value: words.ownerAddressMustBeFilled[state.language] });
  //   return;
  // }

  if (stateFixed.royaltyPercentage === undefined || stateFixed.royaltyPercentage === null || stateFixed.royaltyPercentage === '') {
    stateFixed.royaltyPercentage = 0;
  }

  if (stateFixed.action !== 'grant' && stateFixed.action !== 'revoke') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.selectGrantOrRevoke[state.language] });
    return;
  }

  if (stateFixed.mode !== 'individual' && stateFixed.mode !== 'inclusive') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.selectIndividualOrInclusive[state.language] });
    return;
  }

  // 数量チェック
  if (stateFixed.royaltyPercentage > 90) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.royaltyPercentageMustBeEqualOrSmallerThan90[state.language] });
    return;
  }

  if (stateFixed.royaltyPercentage < 0) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.royaltyPercentageMustBeEqualOrLargerThan0[state.language] });
    return;
  }

  // 複合チェック
  if (stateFixed.action === 'grant') {
    if (stateFixed.royaltyPercentage !== undefined && stateFixed.royaltyPercentage !== null && stateFixed.royaltyPercentage !== '' && stateFixed.royaltyPercentage !== 0) {
      if (stateFixed.addressPayRoyaltyTo === undefined || stateFixed.addressPayRoyaltyTo === null || stateFixed.addressPayRoyaltyTo === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressYouReceiveRoyaltyInMustBeFilled[state.language] });
        return;
      }
    }
  }

  if (stateFixed.mode === 'individual') {
    if (stateFixed.addressPermitTo === undefined || stateFixed.addressPermitTo === null || stateFixed.addressPermitTo === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.addressYouPermitToExhibitMustBeFilled[state.language] });
      return;
    }
  }
  else { // inclusive
    stateFixed.addressPermitTo = '0';
  }

  // const checkResult = await checkMpurseAddress(state, dispatch, stateFixed, 'addressOwner');

  // if (checkResult.status === 'rejected') {
  //   return { status: 'rejected' };
  // }
  // else {
  //   addressActual = checkResult.addressActual;
  // }

  // 署名

  const clientTime = Date.now();

  const getMessage = (addressOwner) => {
    if (stateFixed.mode === 'individual') {
      if (stateFixed.action === 'grant') {
        if (stateFixed.addressPayRoyaltyTo !== undefined && stateFixed.addressPayRoyaltyTo !== null && stateFixed.addressPayRoyaltyTo !== '') {
          return `I permit the owner of ${stateFixed.addressPermitTo} to sell tokens owned(issued) by ${addressOwner} for the ${stateFixed.royaltyPercentage}% royalty. I want receive royalty in ${stateFixed.addressPayRoyaltyTo}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
        }
        else {
          return `I permit the owner of ${stateFixed.addressPermitTo} to sell tokens owned(issued) by ${addressOwner} for the ${stateFixed.royaltyPercentage}% royalty. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
        }
      }
      else { // revoke
        return `I revoke permission for the owner of ${stateFixed.addressPermitTo} to sell tokens owned(issued) by ${addressOwner}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
      }
    }
    else { // inclusive
      if (stateFixed.action === 'grant') {
        if (stateFixed.addressPayRoyaltyTo !== undefined && stateFixed.addressPayRoyaltyTo !== null && stateFixed.addressPayRoyaltyTo !== '') {
          return `I permit inclusively to sell tokens owned(issued) by ${addressOwner} for the ${stateFixed.royaltyPercentage}% royalty. I want receive royalty in ${stateFixed.addressPayRoyaltyTo}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
        }
        else {
          return `I permit inclusively to sell tokens owned(issued) by ${addressOwner} for the ${stateFixed.royaltyPercentage}% royalty. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
        }
      }
      else { // revoke
        return `I revoke inclusive permission to sell tokens owned(issued) by ${addressOwner}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
      }
    }
  };

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  if (stateFixed.addressOwner !== undefined && stateFixed.addressOwner !== null && stateFixed.addressOwner !== '' && keyPairsInPool[stateFixed.addressOwner]?.keyPair !== undefined) {
    const keyPair = keyPairsInPool[stateFixed.addressOwner].keyPair;
    addressActual = stateFixed.addressOwner;

    const result = signWithKey(state, dispatch, keyPair, getMessage(stateFixed.addressOwner), state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    const keyPair = keyPairs[0];
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return { status: 'rejected' };
    }

    // addressOwnerが指定されていれば、アドレスチェックを行う。
    // 指定されていなければ、addressMainActualをaddressOwnerとして扱う。
    if (stateFixed.addressOwner !== undefined && stateFixed.addressOwner !== null && stateFixed.addressOwner !== '') {
      if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressOwner, addressCheck: stateFixed.addressCheck, language: state.language })) {
        return { status: 'rejected' };
      }
    }
    else {
      stateFixed.addressOwner = addressActual;
    }

    result = signWithKey(state, dispatch, keyPair, getMessage(stateFixed.addressOwner), state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (stateFixed.walletType === 'mpurse') {
    const result = await window.mpurse.getAddress()
    .then( (result) => {
      addressActual = result;

      // addressOwnerが指定されていれば、アドレスチェックを行う。
      // 指定されていなければ、addressMainActualをaddressOwnerとして扱う。
      if (stateFixed.addressOwner !== undefined && stateFixed.addressOwner !== null && stateFixed.addressOwner !== '') {
        if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressOwner, addressCheck: stateFixed.addressCheck, language: state.language })) {
          return 'rejected';
        }
      }
      else {
        stateFixed.addressOwner = addressActual;
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    try {
      signature= await window.mpurse.signMessage(getMessage(stateFixed.addressOwner)).then( result => result );
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return;
    }
  }
  else if (
    stateFixed.walletType === 'keypool' &&
    state.active.addressMain !== undefined && state.active.addressMain !== null && state.active.addressMain !== '' &&
    keyPairsInPool[state.active.addressMain]?.keyPair !== undefined
  ) {
    const keyPair = keyPairsInPool[state.active.addressMain].keyPair;
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return { status: 'rejected' };
    }

    // addressOwnerが指定されていれば、アドレスチェックを行う。
    // 指定されていなければ、addressMainActualをaddressOwnerとして扱う。
    if (stateFixed.addressOwner !== undefined && stateFixed.addressOwner !== null && stateFixed.addressOwner !== '') {
      if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: stateFixed.addressOwner, addressCheck: stateFixed.addressCheck, language: state.language })) {
        return { status: 'rejected' };
      }
    }
    else {
      stateFixed.addressOwner = addressActual;
    }

    result = signWithKey(state, dispatch, keyPair, getMessage(stateFixed.addressOwner), state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (stateFixed.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcRequired',
    };
  }
  else if (stateFixed.walletType === 'nfcNative') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcNativeRequired',
    };
  }
  else { // qr
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    return {
      status: 'rejected',
      message: 'bcRequired',
    };
  }

  // GO！

  request.body = JSON.stringify({
    body: {
      method: 'upsert',
      action: stateFixed.action,
      mode: stateFixed.mode,
      addressPermitTo: stateFixed.addressPermitTo,
      addressOwnerActual: addressActual,
      addressOwner: stateFixed.addressOwner,
      addressPayRoyaltyTo: stateFixed.addressPayRoyaltyTo,
      royaltyPercentage: stateFixed.royaltyPercentage,
      clientTime : clientTime,
      signature : signature,
      signatureVersion : stateFixed.signatureVersion,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/permit';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "order expired.": words.orderExpired[state.language],
    "out of service": words.outOfService[state.language],
    "user does not exist.": words.addressIsNotBeRegistered[state.language],
    "you are not delegated from owner address.": words.norIsTheSignatureDelegatedFromOwnerAddress[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressOwner], value: {'sessionId': response.body.sessionId.addressOwner, 'expirationOfSession': response.body.expirationOfSession.addressOwner} });

    if (addressActual !== stateFixed.addressOwner) {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': response.body.sessionId.addressOwnerActual, 'expirationOfSession': response.body.expirationOfSession.addressOwnerActual} });
    }

    // addressOwnerが指定されていなかった場合は、dispatchする。
    if (state.permit.addressOwner === undefined || state.permit.addressOwner === null || state.permit.addressOwner === '') {
      dispatch({ type: 'setStateMultiLayers', keys: ['permit', 'addressOwner'], value: stateFixed.addressOwner });
    }

    // オーダーNo.通知欄表示
    // dispatch({ type: 'setNotification', key: 'notification', value: words.orderAcceptedOrderNo[state.language] + response.body.orderNo + words.orderAcceptedOrderNo2[state.language] });

    // cookie情報更新(アドレス情報)
    const action = stateFixed.action === 'grant' ? 'permitToExhibit' : 'revokePermissionToExhibit';
    const exhibitorName = state.usersGeneralIndex[stateFixed.addressPermitTo] !== undefined ? state.usersGeneralIndex[stateFixed.addressPermitTo].userName : stateFixed.addressPermitTo;
    const cookiesNew = [
          {
            action: action,
            addressType: 'addressOwner',
            description: `${exhibitorName} ${stateFixed.royaltyPercentage}%`,
            time: clientTime,
            address: stateFixed.addressOwner
          },
    ];

    if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressPermitTo ) && stateFixed.mode === 'individual') {
      cookiesNew.push(
          {
            action: action,
            addressType: 'addressPermitTo',
            description: `${exhibitorName} ${stateFixed.royaltyPercentage}%`,
            time: clientTime,
            address: stateFixed.addressPermitTo
          },
      );
    }

    if (stateFixed.action === 'grant') {
      if (stateFixed.addressPayRoyaltyTo !== undefined && stateFixed.addressPayRoyaltyTo !== null && stateFixed.addressPayRoyaltyTo !== '') {
        if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressPayRoyaltyTo )) {
          cookiesNew.push(
              {
                action: action,
                addressType: 'addressPayRoyaltyTo',
                description: `${exhibitorName} ${stateFixed.royaltyPercentage}%`,
                time: clientTime,
                address: stateFixed.addressPayRoyaltyTo
              },
          );
        }
      }
    }

    setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: stateFixed.addressOwner, cookiesNew, clientParameters: state.config.clientParameters });
  }
  else {
  }

  return response;
}


// 「委任」ボタン押下 HANDLE CLICK DELEGATE
async function handleClickDelegate(state, dispatch, cookies, setCookie, keyPairs) {
  let addressActual;
  let request = {};
  let messages = {};
  let addressForSignature;
  // let addressForSignatureKey;
  let signature;

  // state固定
  const stateFixed = {
    action: state.delegate.action,
    addressDelegateFrom: state.delegate.addressDelegateFrom,
    addressDelegateTo: state.delegate.addressDelegateTo,
    signatureVersion: state.config.clientParameters.signatureVersion.delegate,
    addressCheck: state.addressCheck,
    walletType: state.walletType,
  };

  // 必須項目チェック
  if (stateFixed.action === 'accept' || stateFixed.action === 'revokeAcceptance') {
    if (stateFixed.addressDelegateFrom === undefined || stateFixed.addressDelegateFrom === null || stateFixed.addressDelegateFrom === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.addressDelegateFromMustBeFilled[state.language] });
      return { status: 'rejected' };
    }
  }

  if (stateFixed.action === 'request' || stateFixed.action === 'revokeRequest') {
    if (stateFixed.addressDelegateTo === undefined || stateFixed.addressDelegateTo === null || stateFixed.addressDelegateTo === '') {
      dispatch({ type: 'setNotification', key: 'notification', value: words.addressDelegateToMustBeFilled[state.language] });
      return { status: 'rejected' };
    }
  }

  if (stateFixed.action !== 'request' && stateFixed.action !== 'revokeRequest' && stateFixed.action !== 'accept' && stateFixed.action !== 'revokeAcceptance') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.selectRequestOrRevokeRequestOrAcceptOrRevokeAcceptance[state.language] });
    return { status: 'rejected' };
  }

  // 署名する秘密鍵に紐づくアドレス
  if (stateFixed.action === 'request' || stateFixed.action === 'revokeRequest') {
    addressForSignature = stateFixed.addressDelegateFrom;
    // addressForSignatureKey = 'addressDelegateFrom';
  }
  else { // accept or revokeAcceptance
    addressForSignature = stateFixed.addressDelegateTo;
    // addressForSignatureKey = 'addressDelegateTo';
  }

  // 署名
  const clientTime = Date.now();

  const getMessage = (addressForSignature) => {
    if (stateFixed.action === 'request') {
      return `I delegate the signature by the private key pertaining the address ${addressForSignature} to the owner of address ${stateFixed.addressDelegateTo} in monacotto. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    }
    else if (stateFixed.action === 'revokeRequest') {
      return `I revoke the delegation of the signature by the private key pertaining the address ${addressForSignature} to the owner of address ${stateFixed.addressDelegateTo} in monacotto. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    }
    else if (stateFixed.action === 'accept') {
      return `I accept the delegation of the signature by the private key pertaining the address ${stateFixed.addressDelegateFrom} to the owner of address ${addressForSignature} in monacotto. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    }
    else { // revokeAcceptance
      return `I revoke the acceptance of the delegation of the signature by the private key pertaining the address ${stateFixed.addressDelegateFrom} to the owner of address ${addressForSignature} in monacotto. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;
    }
  };

  const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

  if (addressForSignature !== undefined && addressForSignature !== null && addressForSignature !== '' && keyPairsInPool[addressForSignature]?.keyPair !== undefined) {
    const keyPair = keyPairsInPool[addressForSignature].keyPair;
    addressActual = addressForSignature;

    const result = signWithKey(state, dispatch, keyPair, getMessage(addressForSignature), state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (keyPairs !== undefined && keyPairs !== null) {
    const keyPair = keyPairs[0];
    let result;

    result = getAddressFromKey(state, dispatch, keyPair, state.networkMona);

    if (result.status === 'fulfilled') {
      addressActual = result.address;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
      return { status: 'rejected' };
    }

    // addressForSignatureいれば、アドレスチェックを行う。
    // 指定されていなければ、addressMainActualをaddressForSignature
    if (addressForSignature !== undefined && addressForSignature !== null && addressForSignature !== '') {
      if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: addressForSignature, addressCheck: stateFixed.addressCheck, language: state.language })) {
        return { status: 'rejected' };
      }
    }
    else {
      addressForSignature = addressActual;

      if (stateFixed.action === 'request' || stateFixed.action === 'revokeRequest') {
        stateFixed.addressDelegateFrom = addressActual;
      }
      else { // accept or revokeAcceptance
        stateFixed.addressDelegateTo = addressActual;
      }
    }

    result = signWithKey(state, dispatch, keyPair, getMessage(addressForSignature), state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }
  else if (stateFixed.walletType === 'mpurse') {
    const result = await window.mpurse.getAddress()
    .then( (result) => {
      addressActual = result;

      // addressForSignatureいれば、アドレスチェックを行う。
      // 指定されていなければ、addressMainActualをaddressForSignature
      if (addressForSignature !== undefined && addressForSignature !== null && addressForSignature !== '') {
        if (!checkIfAddressIsMatchedWithAnAddress({ dispatch, addressActual, address: addressForSignature, addressCheck: stateFixed.addressCheck, language: state.language })) {
          return 'rejected';
        }
      }
      else {
        addressForSignature = addressActual;
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名
    try {
      signature= await window.mpurse.signMessage(getMessage(addressForSignature)).then( result => result );
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return;
    }
  }
  else if (stateFixed.walletType === 'nfc') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcRequired',
    };
  }
  else if (stateFixed.walletType === 'nfcNative') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    return {
      status: 'rejected',
      message: 'nfcNativeRequired',
    };
  }
  else { // qr
    dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    return {
      status: 'rejected',
      message: 'bcRequired',
    };
  }

  // GO！

  request.body = JSON.stringify({
    body: {
      action: stateFixed.action,
      addressDelegateFrom: stateFixed.addressDelegateFrom,
      addressDelegateTo: stateFixed.addressDelegateTo,
      addressActual: addressActual,
      clientTime: clientTime,
      signature: signature,
      signatureVersion: stateFixed.signatureVersion,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/delegate';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "bad signature, can't recover address": words.badSignatureCanNotRecoverAddress[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "order expired.": words.orderExpired[state.language],
    "out of service": words.outOfService[state.language],
    "user does not exist.": words.addressIsNotBeRegistered[state.language],
    "you are not delegated from delegation source address.": words.norIsTheSignatureDelegatedFromDelegationSourceAddress[state.language],
    "you are not delegated from delegated address.": words.norIsTheSignatureDelegatedFromDelegatedAddress[state.language],
    "success": words.success[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', addressForSignature], value: {'sessionId': response.body.sessionId.addressForVerify, 'expirationOfSession': response.body.expirationOfSession.addressForVerify} });

    if (addressActual !== addressForSignature) {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': response.body.sessionId.addressActual, 'expirationOfSession': response.body.expirationOfSession.addressActual} });
    }

    // addressForSignatureが指定されていなかった場合は、dispatchする。
    if (stateFixed.action === 'request' || stateFixed.action === 'revokeRequest') {
      if (state.delegate.addressDelegateFrom === undefined || state.delegate.addressDelegateFrom === null || state.delegate.addressDelegateFrom === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'addressDelegateFrom'], value: stateFixed.addressDelegateFrom });
      }
    }
    else { // accept or revokeAcceptance
      if (state.delegate.addressDelegateTo === undefined || state.delegate.addressDelegateTo === null || state.delegate.addressDelegateTo === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['delegate', 'addressDelegateTo'], value: stateFixed.addressDelegateTo });
      }
    }

    // オーダーNo.通知欄表示
    // dispatch({ type: 'setNotification', key: 'notification', value: words.orderAcceptedOrderNo[state.language] + response.body.orderNo + words.orderAcceptedOrderNo2[state.language] });

    // cookie情報更新(アドレス情報)
    let action;

    if (stateFixed.action === 'request') {
      action = 'delegate';
    }
    else if (stateFixed.action === 'revokeRequest') {
      action = 'revokeDelegation';
    }
    else if (stateFixed.action === 'accept') {
      action = 'acceptDelegation';
    }
    else { // revokeAcceptance
      action = 'revokeAcceptance';
    }

    const delegatorName = state.usersGeneralIndex[stateFixed.addressDelegateFrom] !== undefined ? state.usersGeneralIndex[stateFixed.addressDelegateFrom].userName : stateFixed.addressDelegateFrom;
    const delegateeName = state.usersGeneralIndex[stateFixed.addressDelegateTo] !== undefined ? state.usersGeneralIndex[stateFixed.addressDelegateTo].userName : stateFixed.addressDelegateTo;

    const cookiesNew = [
          {
            action: action,
            addressType: 'addressDelegateFrom',
            description: `${delegatorName} ${delegateeName}`,
            time: clientTime,
            address: stateFixed.addressDelegateFrom,
          },
    ];

    if (cookiesNew.every( cookie => cookie.address !== stateFixed.addressDelegateTo )) {
      cookiesNew.push(
          {
            action: action,
            addressType: 'addressDelegateTo',
            description: `${delegatorName} ${delegateeName}`,
            time: clientTime,
            address: stateFixed.addressDelegateTo,
          },
      );
    }

    setAddressesInCookie({ dispatch, cookies, setCookie, addressMain: addressForSignature, cookiesNew, clientParameters: state.config.clientParameters });
  }
  else {
  }

  return response;
}

export {
  handleClickGetPermitHistory,
  handleClickGetPermittedHistory,
  handleClickGetPermittedInclusivelyHistory,
  handleClickGetRequestPermissionHistory,
  handleClickGetRequestedPermissionHistory,
  handleClickGetDelegateHistory,
  handleClickGetDelegatedHistory,
  handleClickPermit,
  handleClickRequestPermission,
  handleClickDelegate,
};